export default __webpack_public_path__ + "static/media/ec37f778a1dbe7002452b0585a3d10d01581603080522.6bc33cf6.webp";